// FETCH ALL FILTER
export const FETCH_FILTER_REQUEST = 'FETCH_FILTER_REQUEST';
export const FETCH_FILTER_SUCCESS = 'FETCH_FILTER_SUCCESS';
export const FETCH_FILTER_FAILURE = 'FETCH_FILTER_FAILURE';

// CREATE FILTER
export const CREATE_FILTER_REQUEST = 'CREATE_FILTER_REQUEST';
export const CREATE_FILTER_SUCCESS = 'CREATE_FILTER_SUCCESS';
export const CREATE_FILTER_FAILURE = 'CREATE_FILTER_FAILURE';

// UPDATE FILTER
export const UPDATE_FILTER_REQUEST = 'UPDATE_FILTER_REQUEST';
export const UPDATE_FILTER_SUCCESS = 'UPDATE_FILTER_SUCCESS';
export const UPDATE_FILTER_FAILURE = 'UPDATE_FILTER_FAILURE';

// FETCH SINGLE STATE
export const FETCH_SINGLE_FILTER_REQUEST = 'FETCH_SINGLE_FILTER_REQUEST';
export const FETCH_SINGLE_FILTER_SUCCESS = 'FETCH_SINGLE_FILTER_SUCCESS';
export const FETCH_SINGLE_FILTER_FAILURE = 'FETCH_SINGLE_FILTER_FAILURE';

// DELETE FILTER
export const DELETE_FILTER_REQUEST = 'DELETE_FILTER_REQUEST';
export const DELETE_FILTER_SUCCESS = 'DELETE_FILTER_SUCCESS';
export const DELETE_FILTER_FAILURE = 'DELETE_FILTER_FAILURE';

export const RESET_FILTER_INFO = 'RESET_FILTER_INFO';

export const CREATE_FILTER_FORM = 'CREATE_FILTER_FORM';

export const UPDATE_FILTER_FORM = 'UPDATE_FILTER_FORM';
